import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  { path: '/move', name: 'move', component: () => import('../views/MoveView.vue') },
  { path: '/send', name: 'send', component: () => import('../views/PoseSendView.vue') },
  { path: '/moveonly', name: 'moveonly', component: () => import('../views/MoveOnlyView.vue') },
  { path: '/record', name: 'record', component: () => import('../views/PoseRecorder.vue') },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
